// 二代Yuli中心化合约
const BETA_GEN2_MARKET_CENTER = "0xF7802FCee32542f65138a510115A85D7baA29f7D";
const PROD_GEN2_MARKET_CENTER = "";
export const YULI_GEN2_MARKET_CENTER =
  process.env.NODE_ENV === "production"
    ? PROD_GEN2_MARKET_CENTER
    : BETA_GEN2_MARKET_CENTER;
